<template>
    <div id="headers">
        <div class="carousel-header" id="#top">
            <carousel class="home-carousel" :perPageCustom="[[240, 1], [768, 1], [1024, 1]]" :autoplay="true"
                :autoplayTimeout=3000 :autoplayHoverPause="false" :hoverPause="false" :navigationEnabled="false"
                :paginationEnabled="true" :loop="true">
                <slide :key="index" v-for="(item, index) in blogSlider">
                    <div class='image-slider'
                        :style="`background-image: url(${item.photo.full_size}); cursor: pointer; width: 100%;`">
                        <div target="_blank" class='carousel-text'>
                            <a :href="item.url" target="_blank" v-html="item.title" class='title' />
                            <h2 v-html="item.sub_title" class='sub-title' />
                        </div>
                    </div>
                </slide>
            </carousel>
            <div class="home-box-wrapper">
                <ul class="home_box_container">
                    <li>
                        <div class="home_box">
                            <h2>Записаться на прием онлайн</h2>
                            <div class="news">
                                <div class="text">
                                    Запишитесь на приём к нашему врачу.
                                </div>
                            </div>
                            <div class="home_box-button">
                                <router-link :to="{ name: 'Контакты' }">Читать далее →</router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="home_box">
                            <h2>Записаться на прием по телефону</h2>
                            <div class="news">
                                <div class="text">
                                    <div>
                                        Контактный центр:
                                        <a style="float: right;" href="tel:+74992482720">
                                            <font color="white">+7 (499) 248-27-20</font>
                                        </a>
                                    </div>
                                    <div>
                                        <p style="display: inline-block; height: 14px;"></p>
                                        <a style="float: right;" href="tel:+74992485768">
                                            <font color="white">+7 (499) 248-57-68</font>
                                        </a>
                                    </div>
                                    <div>
                                        Регистратура ОМС:
                                        <a style="float: right;" href="tel:+74956208106">
                                            <font color="white">+7 (495) 620-81-06</font>
                                        </a>
                                    </div>
                                    <div>
                                        Регистратура ДМС:
                                        <a style="float: right;" href="tel:+74956208105">
                                            <font color="white">+7 (495) 620-81-05</font>
                                        </a>
                                    </div>
                                    <div>
                                        Платные мед. услуги:
                                        <a style="float: right;" href="tel:+74996208107">
                                            <font color="white">+7 (495) 620-81-07</font>
                                        </a>
                                    </div>
                                    <div>
                                        Стоматология:
                                        <a style="float: right;" href="tel:+74992483106">
                                            <font color="white">+7 (499) 248-31-06</font>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="home_box-button">
                                <router-link :to="{ name: 'Контакты' }">Читать далее →</router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="home_box">
                            <h2>График работы</h2>
                            <div class="news">
                                <div class="text">
                                    <div class="items_list">
                                        <div class="items_list-row">
                                            <span>Понедельник - Пятница</span>
                                            <div class="value">8.00 - 20.00</div>
                                        </div>
                                        <div class="items_list-row">
                                            <span>Суббота</span>
                                            <div class="value">9.00 - 17.00</div>
                                        </div>
                                        <div class="items_list-row">
                                            <span>Воскресенье</span>
                                            <div class="value">Выходной День</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="main-content-wrapper">
            <div class="home-news">
                <h3 class="content-title">
                    Последние новости
                </h3>
                <!--   Articles -->
                <div class="news-container">
                    <Article :data="data" :key="$index" v-for="(data, $index) in news" />
                </div>
                <!--   Articles -->
                <div class="show_all">
                    <router-link :to="{ name: 'Новости' }">Показать все →</router-link>
                </div>


                <h3 class="content-title">
                    Акции
                </h3>
                <!--   Offers -->
                <div class="news-container">
                    <Article :data="data" :key="$index" :is-offer="true" v-for="(data, $index) in offers" />
                </div>
                <!--   Offers -->
                <div class="show_all">
                    <router-link :to="{ name: 'Акции' }">Показать все →</router-link>
                </div>
                <!--   Inforamtion -->
                <div class="home-info">
                    <h3 class="content-title">
                        Обращение Главного Врача
                    </h3>
                    <div class="home-info-video">
                        <iframe id="rutube-player" width="500" height="281"
                            src="https://rutube.ru/play/embed/188b0f7d1cb62b913b5c4afcf0a8ede0?isfulltab=true"
                            frameborder="0" webkitAllowFullScreen mozallowfullscreen allowfullscreen scrolling="no"
                            allow="autoplay *; encrypted-media *;" />
                    </div>
                    <h3 class="home-info-sentence">В суете мегаполиса мы, к сожалению, задумываемся о своем здоровье
                        лишь в тот момент, когда оно начинает подводить. Именно поэтому специалисты нашей клиники, ломая
                        стереотипы, ждут вас тогда, когда вы еще полны сил, чтобы сохранить ваши бесценные и
                        невосполнимые сокровища — молодость и здоровье — на долгие годы!</h3>
                    <div class="home-info-sub-sentence">
                        С уважением, Главный врач ФГБУ «Поликлиника №5» <br>

                        Управления делами Президента Российской Федерации, <br>

                        д.м.н. Александрова Елена Борисовна
                    </div>

                    <h3 class="content-title hide">
                        Наши Преимущества
                    </h3>
                    <!--   Inforamtion -->
                </div>
            </div>
            <div class="directions">
                <h3 class="content-title">
                    Направления
                </h3>

                <div class="directions-content">
                    <department-item :show-direction="showDirection === direction.title" @direct="clickedChild"
                        :data="direction" v-for="direction of departmentListing" :key="direction.slug" />
                </div>
            </div>
        </div>

        <div class="advantages">
            <div class="advantage-item">
                <img src="../assets/images/img_003-75x75-2.png" alt="adv">
                <span>Лучшие традиции “Кремлевской медицины”</span>
            </div>
            <div class="advantage-item">
                <img class="width-45-per" src="../assets/images/img_002-100x75-ico.png" alt="adv">
                <span>Работаем с</span>
            </div>
            <div class="advantage-item">
                <img src="../assets/images/img_004-100x90-2.png" alt="adv">
                <span>Новейшее оборудование</span>
            </div>
            <div class="advantage-item">
                <img src="../assets/images/img_006-75x75-2.png" alt="adv">
                <span>В центре Москвы</span>
            </div>
            <div class="advantage-item">
                <img src="../assets/images/img_001-75x75-2.png" alt="adv">
                <span>Все услуги в одной поликлинике</span>
            </div>
            <div class="advantage-item">
                <img src="../assets/images/img_005-75x75-2.png" alt="adv">
                <span>Специалисты высокой квалификации</span>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Article from '../components/ArticleHome';
import { mapActions, mapGetters } from "vuex";
import DepartmentItem from "../components/DepartmentItem";
// @ is an alias to /src
export default {
    name: 'Home',
    components: {
        Carousel,
        Slide,
        Article,
        DepartmentItem
    },
    data() {
        return {
            showDirection: '',
            showDirection2: false,
        };
    },
    computed: {
        ...mapGetters(["blogSlider", "news", "offers", "departmentListing"])
    },
    methods: {
        ...mapActions(["fetchBlogSlider", "fetchHomepageNews", "fetchHomepageOffers", "fetchDepartmentListing"]),
        clickedChild(value) {
            this.showDirection = value
        }
    },
    mounted() {
        this.fetchBlogSlider();
        this.fetchHomepageNews();
        this.fetchHomepageOffers({ includeSpecials: 1 });
        this.fetchDepartmentListing();
        const player = document.getElementById('rutube-player');
        player.contentWindow.postMessage(JSON.stringify({
            type: 'player:remove'
        }), '*');
        this.$nextTick(() => {
            player.contentWindow.postMessage(JSON.stringify({
                type: 'player:changeVideo',
                data: {
                    id: '188b0f7d1cb62b913b5c4afcf0a8ede0'
                }
            }), '*');
        })
    }
}
</script>

<style>
.home-news .news-content {
    width: unset !important;
}

.home-news .news-item {
    width: 45% !important;
}
</style>

<style scoped>
.carousel {
    width: 100vw;
    height: 400px;
    background-color: #707070;
}

.example-slide {
    align-items: center;
    background-color: #666;
    color: #999;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    min-height: 10rem;
}

img {
    width: 100%;
}

.image-slider {
    background-size: cover;
    background-position: center;
    height: 670px;
}

.carousel-header {
    position: relative;
}

.home-box-wrapper {
    width: 100vw;
    position: absolute;
    bottom: -45px;
    display: flex;
    justify-content: center;
    z-index: 9;
    margin-left: auto;
    margin-right: auto;
    -webkit-animation-timing-function: cubic-bezier(.75, 0, .25, 1);
    -webkit-animation-name: slideRight;
}

.home_box_container {
    display: flex;
    text-align: left;
    max-width: 990px;
}

.home_box_container li {
    padding: 21px 30px 30px;
    height: 210px;
}

.home_box_container li:first-child {
    background-color: rgb(0, 182, 204);
}

.home_box_container li:nth-child(2) {
    background-color: rgb(0, 151, 181);
    padding: 21px 30px 50px 30px;
    min-height: 255px;
}

.home_box_container li:nth-child(3) {
    background-color: rgb(0, 102, 136);
}

.home_box {
    width: 270px;
}

.home_box h2 {
    color: #fff;
    font-size: 23px;
    line-height: 1;
}

.home_box .news {
    margin-top: 15px;
    font-size: 13px;
    color: #fff;
}

.home_box-button {
    margin-top: 25px;
}

.home_box-button a {
    padding: 5px 24px 5px 8px;
    color: rgb(255, 255, 255);
    background-color: transparent;
    border: 1px solid #fff;
    font-size: 13px;
}

.tel {
    border-bottom: 1px dotted #3156A3;
}

.home_box-button a:hover {
    background-color: #fff;
    color: #1a1a1a;
}

.home_box .items_list-row:first-child {
    padding-top: 0;
}

.items_list-row {
    border-bottom: 1px solid #007796;
    display: flex;
    font-size: 13px;
    justify-content: space-between;
    padding: 8px 0;
    height: unset;
    background-color: unset;
}


/*  main content*/

.main-content-wrapper {
    display: flex;
    max-width: 990px;
    margin: 80px auto 40px;
}

.directions {
    width: 30%;
    margin-left: 25px;
}

.directions-item {
    /*width: 100%;*/
    border-bottom: 1px solid #E0E0E0;
}

.directions-content {
    margin-top: 20px;
}

.direction-content.active {
    background-color: #006688;
    color: #fff;
    padding: 12px 13px 12px 12px;
}

.direction-content:not(.active):hover h3 {
    color: #006688;
}

.direction-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 100%;
    text-align: left;
    font-size: 13px;
    padding: 12px 13px 12px 0;
    background: transparent;
    color: #666;
    font-weight: 400;
}

.collapsed-image {
    margin: 10px 0;
    display: flex;
}

.collapsed-content {
    visibility: hidden;
    z-index: 0;
    height: 0;
    display: none;
}

.collapsed-content .minus {}

.collapsed-content.show {
    visibility: visible;
    z-index: 1;
    display: block;
    height: auto;
}

.collapsed-desc {
    padding: 1em 0;
    color: #666;
    text-align: left;
}

.collapsed-image img {
    width: 30%;
}

.collapsed-button {
    color: #58b9da;
    width: 230px;
    padding: 10px 14px;
    border: 2px solid #58b9da;
    margin-bottom: 20px;
    background-color: transparent;
    font-size: 13px;
    cursor: pointer;
}

.collapsed-button:hover {
    background-color: #58b9da;
    color: #fff;
}


.home-news {
    width: 70%
}


.news-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.home-news .show_all {
    display: flex;
    justify-content: flex-end;
}

.home-news .show_all a {
    color: #006688;
    cursor: pointer;
    font-weight: bold;
    width: fit-content;
    border-bottom: 1px dotted #006688;
    font-size: 12px;
    margin: 4px 0;
    text-align: right;
}

/*  info*/

.home-info-video {
    margin-top: 20px;
}

.home-info-video iframe {
    width: 100%;
}

.home-info-sentence {
    font-family: 'Volkhov', sans-serif;
    color: #3156A3;
    text-align: left;
    font-size: 16px;
    font-style: italic;
    margin-top: 25px;
}

.home-info-sub-sentence {
    font-size: 14px;
    color: #666;
    text-align: left;
    font-weight: bold;
    margin: 20px 0;
}

.advantages {
    max-width: 996px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.advantage-item {
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
    position: relative;
    height: 150px;
}

.advantage-item img {
    width: 30%;
}

.advantage-item img.width-45-per {
    width: 45%;
}

.advantage-item span {
    font-size: 14px;
    position: absolute;
    bottom: 0;
}


@media screen and (max-width: 940px) {
    .home_box {
        width: 200px;
    }
}

@media screen and (max-width: 768px) {
    .news-container {
        display: block;
    }

    .main-content-wrapper {
        flex-direction: column;
        justify-content: center;
        align-items: center;

    }

    .hide {
        display: none;
    }

    .directions {
        width: 70%;
    }


    .header_container {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .news-item {
        width: 100% !important;
    }

    .advantages {
        flex-wrap: wrap;
        justify-content: center;
    }

    .advantage-item {
        width: 280px;
    }

    .home-box-wrapper {
        position: unset;
    }

    .home_box_container {
        flex-direction: column;
        margin-top: -60px;
        z-index: 1;
    }

    .home_box_container li {
        width: 75%;
        margin: 0 auto;
        text-align: left;
        padding: 21px 30px 30px !important;
        min-height: unset !important;
        height: auto;
    }

    .header-layout {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .home_box {
        width: 100%;
    }
}

@media screen and (max-width: 480px) {
    .home_box_container li {
        width: 80%;
        min-height: 235px !important;
    }
}
</style>

<style lang="scss">
.red {
    color: #ff2235 !important;
}

.home-carousel .image-slider {
    background-size: cover;
    background-position: center;
    height: 670px;
    display: flex;
}

.home-carousel .image-slider .title {
    font-size: 62px;
    text-align: left;
    line-height: 1;
    color: #FFF;
    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.5);
}

.home-carousel .carousel-text {
    padding: 100px 12px 10px;
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}

.home-carousel .image-slider .sub-title {
    margin-top: 19px;
    line-height: 150%;
    color: #FFF;
    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.5);
    text-align: left;
}

.home-carousel .VueCarousel-pagination {
    position: absolute;
    bottom: 225px;
}

.home-carousel .VueCarousel-dot {
    background-color: transparent !important;
    width: 90px !important;
    height: 10px;
    outline: none !important;
    counter-increment: my-awesome-counter;

    &--active::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        padding: 0 !important;
        visibility: visible;
        width: 110px !important;
        height: 3px !important;
        border-radius: unset !important;
        background-color: rgb(239, 239, 239) !important;
    }
}

.home-carousel .VueCarousel-dot-container {
    position: relative;
}

.home-carousel .VueCarousel-dot-container {}

.home-carousel .VueCarousel-dot {
    counter-increment: my-awesome-counter;
}

.home-carousel .VueCarousel-dot-container::after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 9px;
    background-color: #fff;
    opacity: .7;
}

.home-carousel .VueCarousel-dot-container button {
    position: relative;
}

.home-carousel .VueCarousel-dot-container button:first-child::before {
    content: counter(my-awesome-counter);
    display: block;
    width: 0;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: 9px;
    font-size: 11px;
    color: white;
}


.home-carousel .VueCarousel-dot-container button::before {
    content: counter(my-awesome-counter);
    display: block;
    width: 0px;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: 9px;
    font-size: 11px;
    color: white;
}

.home-carousel .VueCarousel-dot-container button.VueCarousel-dot--active::before {
    //bottom: -5px;
}

@media screen and (max-width: 768px) {
    .home-carousel {

        .VueCarousel-pagination {
            bottom: 80px;
        }

        .image-slider {
            height: 340px;
        }

        .carousel-text {
            padding-top: 50px;

            .title {
                font-size: 35px;
            }
        }

        .VueCarousel-dot {

            width: 40px !important;

            &--active {
                position: absolute;
                bottom: 10px;
                width: 60px !important;
            }
        }

        .carousel-text {
            width: 85%;
        }
    }
}
</style>
